<div
    class="container-fluid well"
    data-test-automation="compiled-from">
    <h5>{{title}}</h5>
    <div class="row">
        @for (setting of settings; track setting) {
            <div class="col-xs-4">
                <label class="control-label">Compiled from {{setting.description}}</label>
                @for (
                    compiledFromReference of getCompiledReferencesBySetting(setting.filterValue);
                    track compiledFromReference;
                    let referenceIndex = $index
                ) {
                    <div
                        class="compiled-from-reference"
                        data-test-automation="reference">
                        <label
                            class="control-label"
                            for="compiledFromReference{{setting.filterValue}}{{referenceIndex}}"
                            style="display: none">
                            Compiled from {{setting.description}} number</label
                        >
                        @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                            <div>
                                <div
                                    class="input-group"
                                    [ngClass]="{'has-error': compiledFromReferenceInput | formFieldHasError}">
                                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                    <input
                                        type="text"
                                        #compiledFromReferenceInput="ngModel"
                                        [name]="'compiledFromReferenceInput-'+setting.filterValue+referenceIndex"
                                        class="form-control"
                                        id="compiledFromReference{{setting.filterValue}}{{referenceIndex}}"
                                        min="0"
                                        [maxlength]="setting.size"
                                        placeholder="Enter Reference"
                                        [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                        [(ngModel)]="compiledFromReference.reference"
                                        (ngModelChange)="compiledFromReferenceChanged(compiledFromReference)"
                                        title="Enter or modify the compiled from {{setting.description}} "
                                        [nlrPattern]="setting.pattern"
                                        [required]="!isReferenceProvided()"
                                        data-test-automation="reference" />
                                    @if (canAddReference(compiledFromReference,setting.pattern) && !readonly) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-add"
                                                tabindex="0"
                                                [ngClass]="{'disabled': (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly}"
                                                (click)="!readonly && addCompiledFromReference(setting.filterValue)"
                                                title="Add another {{setting.description}}"
                                                data-test-automation="add-reference"></i>
                                        </span>
                                    }
                                    @if (canRemoveReference(compiledFromReference)  && !readonly) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-remove"
                                                tabindex="0"
                                                [ngClass]="{'disabled':(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly}"
                                                (click)="!readonly && removeCompiledFromReference(compiledFromReference)"
                                                title="Remove the {{setting.description}}"
                                                data-test-automation="remove-reference"></i>
                                        </span>
                                    }
                                </div>
                                @if (compiledFromReferenceInput | formFieldHasError) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{setting.patternMessage}}</span>
                                    </div>
                                }
                                @if (isDuplicate(compiledFromReference)) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{setting.description}} has to be unique.</span>
                                    </div>
                                }
                                @if (
                                    compiledFromReferenceInput.errors?.required && (compiledFromReferenceInput.invalid && compiledFromReferenceInput.dirty)
                                ) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>Compiled from plan, field record or title is mandatory.</span>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
</div>
<!-- TODO -->
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidCompiledFromText}}</span>-->
<!--</div>-->
